module.exports = __webpack_public_path__ + "static/media/mobile-vibrate.d159aabe.svg";